import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import NotificationService from "../../services/NotificationService";

const STATUS = {
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

function getToken(search) {
  return new URLSearchParams(search || "").get("token");
}

function LessonReminderUnsubscribe({ location }) {
  const [status, setStatus] = useState(STATUS.LOADING);
  const [message, setMessage] = useState("Wyłączanie przypomnień...");

  useEffect(() => {
    const token = getToken(location.search);

    if (!token) {
      setStatus(STATUS.ERROR);
      setMessage("Link jest nieprawidłowy");
      return;
    }

    NotificationService.unsubscribeFromLessonReminders(token)
      .then(() => {
        setStatus(STATUS.SUCCESS);
        setMessage("Przypomnienia zostały wyłączone");
      })
      .catch(() => {
        setStatus(STATUS.ERROR);
        setMessage("Link jest nieprawidłowy");
      });
  }, [location.search]);

  return (
    <main id="parent" className="quiz-text blurred-background">
      <div className="container-fluid">
        <div className="pt-2 row content">
          <div className="col-xl-2" />
          <div className="col-xl-8">
            <h2><strong>{message}</strong></h2>
            {status === STATUS.SUCCESS && (
              <p>Nie będziemy wysyłać kolejnych przypomnień o zajęciach.</p>
            )}
            {status === STATUS.ERROR && (
              <div className="alert alert-danger" role="alert">
                Nie możemy wyłączyć przypomnień z tego linku. Skontaktuj się ze szkołą, jeśli problem się powtórzy.
              </div>
            )}
          </div>
          <div className="col-xl-2" />
        </div>
      </div>
    </main>
  );
}

LessonReminderUnsubscribe.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

export default LessonReminderUnsubscribe;
